export enum EventType {
  /**************************
   *
   * General event type
   *
   **************************/
  ART_AND_PERFORMANCE = 'ART_AND_PERFORMANCE',
  BROKERAGE = 'BROKERAGE',
  COMPETITION_CONTEST = 'COMPETITION_CONTEST',
  ENTREPRENEUR_S_DAY = 'ENTREPRENEUR_S_DAY',
  EXHIBITION_FAIR = 'EXHIBITION_FAIR',
  FINANCE_FORUM = 'FINANCE_FORUM',
  GLOBAL_EVENT_ACTIVITY_WITH_SEVERAL_TYPES_OF_EVENTS = 'GLOBAL_EVENT_ACTIVITY_WITH_SEVERAL_TYPES_OF_EVENTS',
  LECTURE_CONFERENCE = 'LECTURE_CONFERENCE',
  MENTORING = 'MENTORING',
  NETWORKING = 'NETWORKING',
  TRAINING = 'TRAINING',
  WORKSHOP_SEMINAR = 'WORKSHOP_SEMINAR',
  /**************************
   *
   * EU Entrepreneurship Day for students event type
   *
   **************************/
  ENTREPRENEUR_VISITING_SCHOOL = 'ENTREPRENEUR_VISITING_SCHOOL',
  OPEN_DAY_ON_ENTERPERISE_ENTREPRENEURSHIP = 'OPEN_DAY_ON_ENTERPERISE_ENTREPRENEURSHIP',
  STUDENT_COMPETITION = 'STUDENT_COMPETITION',
  AWARD_CEREMONY = 'AWARD_CEREMONY',
  PROJECT_WORK = 'PROJECT_WORK',
  LECTURES = 'LECTURES',
  /**************************
   *
   * Common event type
   *
   **************************/
  OTHER = 'OTHER',
}
